import * as types from '../mutation-types'
import Vue from 'vue'
import Vapi from 'vuex-rest-api'
import merge from 'lodash/merge'

const module = new Vapi({
  baseURL: Vue.$backendBaseURL,
  state: {
    all: [],
    current: null,
    audios: []
  }
})
.get({
  action: 'listFiles',
  property: 'all',
  path: ({ orgId }) => `/orgs/${orgId}/files`
})
.get({
  action: 'getFile',
  property: 'current',
  path: ({ orgId, id }) => `/orgs/${orgId}/files/${id}`
})
.post({
  action: 'createFile',
  property: 'current',
  path: ({ orgId }) => `/orgs/${orgId}/files`
})
.put({
  action: 'updateFile',
  property: 'current',
  path: ({ orgId, id }) => `/orgs/${orgId}/files/${id}`
})
.getStore()

const state = {
}

const getters = {
  audioList (state) {
    return state.all.filter(item => item.fileType === 'audio')
  },
  audioById (state) {
    return function (id) {
      return state.all.find(item => item.uuid === id) || {}
    }
  }
}

const actions = {
  transformUserRoles ({ commit, state, rootState }) {
    const roles = state.current.roles.map(item => {
      if (item.organizationId === rootState.authentication.currentOrgId) {
        return item.roleId
      }
    })
    commit(types.SET_USER_ROLES, { roles })
  }
}

const mutations = {
  [types.RESET_FILE_STATE] (state) {
    state.all = []
    state.current = null
    state.pending = {
      all: false,
      current: false
    }
    state.error = {
      all: null,
      current: null
    }
  }
}

export default merge(module, {
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/modules/file.js